import React from 'react'
import ViewEmployeeComp from '../components/ViewEmployeeComp'

export default function ViewEmployee() {
  return (
    <>
     <ViewEmployeeComp/>
    </>
  )
}
